import { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import getFiltroPermissao from '../../../service/getFiltroPermissao';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Messages } from 'primereact/messages';
import { Dropdown } from 'primereact/dropdown';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { mascaraCpfCnpj } from '../../../utils';
import { Nullable } from 'primereact/ts-helpers';

export default function FiltroAutomotiva({
    onProcess,
    onClose
  }: {
    onProcess: (filterWeb : FilterWeb, automotiva: boolean) => void
    onClose: () => void
  }) {
  const { t } = useTranslation();
  const {state} = useGlobalState();
  const [placa, setPlaca] = useState<Nullable<string | null | undefined>>("");
  const [chassi, setChassi] = useState<string>("");
  const [motor, setMotor] = useState<string>("");
  const [documento, setDocumento] = useState<string>("");
  const [renavam, setRenavam] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [filtros, setFiltros] = useState<any[]>([]);
  const msgs = useRef<Messages>(null);
  const [selectedTipoVeiculo, setselectedTipoVeiculo] = useState();
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | any | null>(null); 
  const tiposVeiculo = [
    { name: "Selecione", code: null },
    { name: "Carros", code: "carros" },
    { name: "Motos", code: "motos" },
    { name: "Caminhões", code: "caminhoes" },
  ];

  const mensagemErroFiltro = (mensagem : string) => {
    window.scrollTo(0, 0);
    msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: mensagem, closable: false }
        
      ]);
  }

  const changeFilter = (value:any) => {
    getFiltroPermissao(value.key).then((data) => {
      setSelectedFilter(value);
      setFiltros(data);
    })
  }

  const validFiltro = (filteWeb :FilterWeb, filtro:any) => {
    if(filtro.tipoFiltro.includes("MOTOR") && filtro.obrigatorio && !filteWeb.motor){
      return false;
    }
    if(filtro.tipoFiltro.includes("PLACA") && filtro.obrigatorio && !filteWeb.placa){
      return false;
    }
    if(filtro.tipoFiltro.includes("CHASSI") && filtro.obrigatorio && !filteWeb.chassi){
      return false;
    }
    if(filtro.tipoFiltro.includes("RENAVAM") && filtro.obrigatorio && !filteWeb.renavam){
      return false;
    }
    if(filtro.tipoFiltro.includes("DOCUMENTO") && filtro.obrigatorio && !filteWeb.documento){
      return false;
    }
    if(filtro.tipoFiltro.includes("TIPO_VEICULO") && filtro.obrigatorio && !filteWeb.tipoVeiculo){
      return false;
    }
    return true;
  }

  const valid = (filteWeb :FilterWeb) => {
    if(filteWeb.consultas.length === 0){
       mensagemErroFiltro('Opções de consulta obrigatório')
       return false;
    }
    let retorno = true;
    filtros.forEach((filtro:any) => {
      if(!validFiltro(filteWeb, filtro)){
        if(!filtro.obrigatorioMinimo || !verifyObrigatorioMinimo(filteWeb, filtro)){
          mensagemErroFiltro(filtro.descricao + ' obrigatório');
          retorno = false;
          return false;
        }
      }
    })


    return retorno;
  }


  const verifyObrigatorioMinimo = (filteWeb :FilterWeb, filtro:any) => {
    let retorno = true;
    filtros.filter((s1:any) => s1.tipoFiltro !== filtro.tipoFiltro && s1.obrigatorioMinimo ).forEach((f:any) => {
      retorno = validFiltro(filteWeb, f);
      if(retorno){
        return true;
      }
    })
  
    if(retorno){
      return true;
    }
    else{
      return false;
    }
  }

  const processConsulta = () => {

    let opcoes: string[] = [];
    if(selectedFilter){
      opcoes.push(selectedFilter.key);
    }
    
   
    const filteWeb :FilterWeb = {
      documento: documento,
      placa: placa,
      consultas: opcoes,
      valor: null,
      arrojado: null,
      usual:null,
      conservador: null,
      indicadores: []
    };
    if(valid(filteWeb)){
      onProcess(filteWeb, true);
    }
   
  }

  const handleDocumento = (event:any) => {
    event.target.value = mascaraCpfCnpj(event.target.value)
  }
const createOptions = () =>{
  const option : any[] = [];

  state.user.consultas.filter((f: {
    permissoes: any;
    tipoConsulta: string; 
  }) => f.tipoConsulta ===  'AUTO')
  .sort( (a:any,b:any) => {
      if(!a.ordenacao){
        return 1;
      }

      if(!b.ordenacao){
        return -1;
      }

      if (a.ordenacao > b.ordenacao) {
        return 1;
      }
      if (a.ordenacao < b.ordenacao) {
        return -1;
      }
      return 0;
  } )
  .forEach((element: any) => {
      const filhos = element.permissoes ? element.permissoes.filter((f: {
        tipoConsulta: string;
      }) => f.tipoConsulta ===  'AUTO') : [];
      if(filhos.length > 0){
        option.push({label:element.label, informativo: element.informativo, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(filhos) : []});
      }

    });
          expandAll(option)      
  return option;
}

const expandNode = (node:any, _expandedKeys:any) => {
  if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;

      for (let child of node.children) {
          expandNode(child, _expandedKeys);
      }
  }
};

const expandAll = (option:any) => {
  let _expandedKeys = {};

  for (let node of option) {
      expandNode(node, _expandedKeys);
  }

 return _expandedKeys;
};

const createPermissoesFilhos = (permissoes:any[]) => {
  const option : any[] = [];
  if(permissoes){
    permissoes
    .sort( (a:any,b:any) => {
        if(!a.ordenacao){
          return 1;
        }

        if(!b.ordenacao){
          return -1;
        }

        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
    } )
    .forEach((element: {
      children: any; label: string; informativo: string; value: string; permissoes:any[]  
    }) => {
      
      option.push({label:element.label, informativo: element.informativo, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
        tipoConsulta: string; 
      }) => f.tipoConsulta === 'AUTO')) : []});
    });
  }
  return option;
}
const nodeTemplate = (node: any, options: { className: string | undefined; }) => {
  let label = <span><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} /><label htmlFor={node.key} className="ml-2">{node.label}</label>{node.informativo && ( <i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{paddingLeft: '1.5rem', color: '#183462', fontSize: '1.2rem'}} className="custom-target-icon pi pi-question-circle"></i>)}</span>;
  if (node.children.length !== 0) {
     label = <b>{node.label}</b>;
  }

  return label;
}
const footerContent = (
  <React.Fragment>
        <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Consultar"  onClick={processConsulta} />
        <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setFiltros([])} className="p-button-text" />
  </React.Fragment>
  );

  

  return (<>
    <Panel header={t('consultaAutomotiva')}>
        <div className=" p-fluid flex flex-wrap gap-3">
          <Tree filter filterMode="lenient" nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(createOptions())} value={createOptions()} selectionMode="single" selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
        </div>
 
    </Panel>
    <Dialog header={selectedFilter?.label} visible={filtros.length > 0} style={{ width: '80vw' }} onHide={() => setFiltros([])} footer={footerContent}>
      <Messages ref={msgs} />
      {filtros.filter((s1:any) => s1.tipoFiltro === 'PLACA').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="placa" className={filtros.filter((s1:any) => s1.tipoFiltro === 'PLACA')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Placa</label>
            <InputMask id="placa" value={placa} onChange={(e)=>{setPlaca(e.target.value);}} onBlur={(e)=>{setPlaca(e.target.value);}} mask="aaa-9*99" placeholder="Placa" required></InputMask>
          </div>
          <br></br>
        </>
      )}

      {filtros.filter((s1:any) => s1.tipoFiltro === 'CHASSI').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="chassi" className={filtros.filter((s1:any) => s1.tipoFiltro === 'CHASSI')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Chassi</label>
            <InputText id="chassi" value={chassi} onChange={(e)=>{setChassi(e.target.value);}}  placeholder="Chassi" required></InputText>
          </div>
          <br></br>
        </>
      )}
      
      {filtros.filter((s1:any) => s1.tipoFiltro === 'MOTOR').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="motor" className={filtros.filter((s1:any) => s1.tipoFiltro === 'MOTOR')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Motor</label>
            <InputText id="motor" value={motor} onChange={(e)=>{setMotor(e.target.value);}}  placeholder="Motor" required></InputText>
          </div>
          <br></br>
        </>
      )}

      {filtros.filter((s1:any) => s1.tipoFiltro === 'RENAVAM').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="renavam" className={filtros.filter((s1:any) => s1.tipoFiltro === 'RENAVAM')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Renavam</label>
            <InputText id="renavam" value={renavam} onChange={(e)=>{setRenavam(e.target.value);}}  placeholder="Renavam" required></InputText>
          </div>
          <br></br>
        </>
      )}

      {filtros.filter((s1:any) => s1.tipoFiltro === 'DOCUMENTO').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="documento" className={filtros.filter((s1:any) => s1.tipoFiltro === 'DOCUMENTO')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Documento</label>
            <InputText id="documento" onKeyUp={handleDocumento} value={documento} onChange={(e)=>{setDocumento(e.target.value);}}  placeholder="Documento" required></InputText>
          </div>
          <br></br>
        </>
      )}

      {filtros.filter((s1:any) => s1.tipoFiltro === 'TIPO_VEICULO').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="tipoVeiculo" className={filtros.filter((s1:any) => s1.tipoFiltro === 'TIPO_VEICULO')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Tipo Veículo</label>
            <Dropdown
                value={selectedTipoVeiculo}
                onChange={(e) => setselectedTipoVeiculo(e.value)}
                options={tiposVeiculo}
                optionLabel="name"
                style={{width:'18rem'}}
                placeholder="Selecione o tipo veículo"
                optionValue="code"
                className="md:w-14rem"
              />
          </div>
          <br></br>
        </>
      )}


      
    </Dialog>
    </>
  )
}
